import moment from 'moment';
import { Box, Grid, Paper, Button, } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function Calendar({ events, selectedDate, setSelectedDate }) {

    const CustomDay = (props) => {
        const { day, outsideCurrentMonth, ...other } = props;
        const isEventDay = events.some(event => { return moment(event.date).isSame(day, 'day') });
        return (
            <PickersDay
                {...other}
                day={day}
                outsideCurrentMonth={outsideCurrentMonth}
                sx={{
                    ...(isEventDay && {
                        backgroundColor: 'secondary.main',
                        color: 'white',
                        fontWeight: 'bold',
                        '&:hover, &:focus': {
                            backgroundColor: 'secondary.dark',
                        },
                    }),
                }}
            />
        );
    };

    return (
        <Grid item xs={12} md={4}>
            <Paper
                elevation={3}
                sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #fff 0%, #f5f5f5 100%)',
                    boxShadow: '0 8px 32px rgba(0, 31, 63, 0.1)',
                }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateCalendar
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        slots={{ day: CustomDay }}
                        sx={{
                            '& .MuiPickersDay-root.Mui-selected': {
                                backgroundColor: 'primary.main',
                            },
                        }}
                    />
                </LocalizationProvider>

                {selectedDate && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, mb: 1 }}>
                        <Button
                            variant="text"
                            color="secondary"
                            onClick={() => setSelectedDate(null)}
                            sx={{ textTransform: 'none', fontWeight: 'bold' }}
                        >
                            Clear Date Filter
                        </Button>
                    </Box>
                )}
            </Paper>


        </Grid>
    );
}

export default Calendar;
